ACC.autocomplete = {

	_autoload: [
		"bindSearchAutocomplete",
		"bindFormSubmit"
		// "bindDisableSearch"
	],

	bindSearchAutocomplete: function ()
	{
		// extend the default autocomplete widget, to solve issue on multiple instances of the searchbox component
		$.widget( "custom.yautocomplete", $.ui.autocomplete, {
			_create:function(){

				// get instance specific options form the html data attr
				var option = this.element.data("options");
				// set the options to the widget
				this._setOptions({
					minLength: option.minCharactersBeforeRequest,
					displayProductImages: option.displayProductImages,
					delay: option.waitTimeBeforeRequest,
					autocompleteUrl: option.autocompleteUrl,
					source: this.source
				});

				// call the _super()
				$.ui.autocomplete.prototype._create.call(this);

			},
			options:{
				cache:{}, // init cache per instance
				focus: function (){return false;}, // prevent textfield value replacement on item focus
				select: function (event, ui){
					window.location.href = ui.item.url;
				}
			},
			_renderItem : function (ul, item){

				if (item.type == "autoSuggestion"){
					var renderHtml = "<a href='"+ item.url + "' ><div class='name'>" + item.value + "</div></a>";
					return $("<li>")
						.data("item.autocomplete", item)
						.append(renderHtml)
						.appendTo(ul);
				}
				else if (item.type == "productResult" && item.url.replace(ACC.config.encodedContextPath,"") != ""){

					var renderHtml = "<a href='" + item.url + "' >";

					if (item.image != null){
						renderHtml += "<div class='thumb'><img src='" + item.image + "'  /></div>";
					}

					renderHtml += 	"<div class='name'>" + item.value +"</div>";
					renderHtml += 	"<div class='price'>" + item.price +"</div>";
					renderHtml += 	"</a>";
					return $("<li>").data("item.autocomplete", item).append(renderHtml).appendTo(ul);

				}else{

					return $("<li>").data("item.autocomplete", item);
				}
			},
			source: function (request, response)
			{
				var self=this;
				var term = request.term.toLowerCase();
				if (term in self.options.cache)
				{
					return response(self.options.cache[term]);
				}
				if(request.term !== undefined){
					$.getJSON(self.options.autocompleteUrl, {term: request.term}, function (data)
					{
						var autoSearchData = [];
						if(data.suggestions != null){
							$.each(data.suggestions, function (i, obj)
							{
								autoSearchData.push({
									value: obj.term,
									url: ACC.config.encodedContextPath + "/search?text=" + obj.term,
									type: "autoSuggestion"
								});
							});
						}
						if(data.products != null){
							$.each(data.products, function (i, obj)
							{
								autoSearchData.push({
									value: ACC.autocomplete.escapeHTML(obj.name),
									code: obj.code,
									desc: obj.description,
									manufacturer: obj.manufacturer,
									url:  ACC.config.encodedContextPath + obj.url,
									price: obj.price ? obj.price.formattedValue : '',
									type: "productResult",
									image: (obj.images!=null && self.options.displayProductImages) ? obj.images[0].url : null // prevent errors if obj.images = null
								});
							});
						}
						self.options.cache[term] = autoSearchData;
						return response(autoSearchData);
					});
				}else{
					console.error("Couldn't send request due to terms being undefined");
				}

			}

		});


		$search = $(".js-site-search-input");
		if($search.length>0){
			$search.yautocomplete()
		}

	},

	bindDisableSearch: function ()
	{
		$('.js-site-search-input').keyup(function() {
			$(this).val($(this).val().replace(/^\s+/gm,''));
			// $(this).parent().find('.js_search_button').prop('disabled', this.value == "" ? true : false);
		})
	},

	bindFormSubmit: function () {
		$('.js-site-search-input').parents('form').on("submit", function(event){
			$(event.target).find('.js-site-search-input').val($(event.target).find('.js-site-search-input').val().trim());

			$(event.target).on('submit', function() {
				return false;
			});
		});
	},

	escapeHTML: function (input) {
		return input.replace(/&/g,'&amp;')
			.replace(/</g,'&lt;')
			.replace(/>/g,'&gt;');
	}

};
